module.exports = __webpack_public_path__ + "img/collection_logo.362deeec.svg";